import { Container } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Grid2";
import NewYorkCity from "../../../../assets/images/destinations/new_york_city.jpg";
import auckland from "../../../../assets/images/destinations/auckland.jpg";
import berlin from "../../../../assets/images/destinations/berlin.jpg";
import lisbon from "../../../../assets/images/destinations/lisbon.jpg";
import london from "../../../../assets/images/destinations/london.jpg";
import paris from "../../../../assets/images/destinations/paris.jpg";
import sydney from "../../../../assets/images/destinations/sydney.jpg";
import toronto from "../../../../assets/images/destinations/toronto.jpg";
import SectionHeader from "../../../../components/typography/SectionHeader";

const DestinationCard = ({ title, location, rating, imageUrl }) => (
  <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-2xl">
    <div
      className="h-64 bg-cover bg-center w-full transition-transform duration-300 group-hover:scale-110"
      style={{ backgroundImage: `url(${imageUrl})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
    <div className="absolute bottom-4 left-4 text-white">
      <h3 className="text-xl font-bold mb-1">{title}</h3>
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className="w-4 h-4 text-yellow-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    </div>
    <div className="absolute top-4 left-4">
      <span className="px-3 py-1 bg-blue-500 text-white text-sm font-semibold rounded-full">
        {location}
      </span>
    </div>
  </div>
);

const Destinations = () => {
  const destinations = [
    {
      title: "New York City",
      location: "USA",
      imageUrl: NewYorkCity,
      rating: 5,
    },
    {
      title: "London",
      location: "UK",
      imageUrl: london,
      rating: 5,
    },
    {
      title: "Toronto",
      location: "Canada",
      imageUrl: toronto,
      rating: 5,
    },
    {
      title: "Sydney",
      location: "Australia",
      imageUrl: sydney,
      rating: 5,
    },
    // {
    //   title: "Berlin",
    //   location: "Germany",
    //   imageUrl: berlin,
    //   rating: 5,
    // },
    {
      title: "Lisbon",
      location: "Portugal",
      imageUrl: lisbon,
      rating: 5,
    },
    {
      title: "Paris",
      location: "France",
      imageUrl: paris,
      rating: 5,
    },
    // {
    //   title: "Auckland",
    //   location: "New Zealand",
    //   imageUrl: auckland,
    //   rating: 5,
    // },
  ];

  return (
    <Container>
      <Grid container spacing={2} alignItems="center" className="my-14">
        <Grid size={{ xs: 12, md: 6 }}>
          <SectionHeader
            tagline="POPULAR DESTINATION"
            title="TOP NOTCH DESTINATION"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <p className="text-gray-600 mt-4">
            Discover the world’s most sought-after destinations for education,
            leisure, and growth. Whether you're pursuing academic excellence or
            planning an unforgettable journey, these destinations offer
            unmatched opportunities, vibrant cultures, and enriching
            experiences.
          </p>
        </Grid>
      </Grid>

      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"> */}
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        {destinations.map((destination, index) => (
          <Grid size={{ xs: 12, md: 3 }}>
            <DestinationCard
              key={index}
              title={destination.title}
              location={destination.location}
              imageUrl={destination.imageUrl}
              rating={destination.rating}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Destinations;
